<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-form label-position="left" inline class="table-expand">
                            <el-form-item label="用户昵称:">
                                <span>{{ props.row.nickName }}</span>
                            </el-form-item>
                            <el-form-item label="意见:">
                                <span>{{ props.row.description }}</span>
                            </el-form-item>
                            <el-form-item label="反馈图片:" style="display:flex">
                                <el-image
                                style="width: 100px; height: 100px"
                                :src="item"
                                :preview-src-list="props.row.pathList"
                                fit="cover" v-for="(item,index) in props.row.pathList" :key="index"></el-image>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="userId" label="用户ID" align="center" width="120px"></el-table-column>
                <el-table-column prop="phone" label="用户手机" align="center" width="200px"></el-table-column>
                <el-table-column prop="nickName" label="用户昵称" align="center" width="200px"></el-table-column>
                <el-table-column prop="description" label="意见" align="center"></el-table-column>
                <el-table-column prop="chuli" label="处理状态" align="center" width="120px">
                    <template slot-scope="scope">
                        {{ scope.row.chuli ? '已处理' : '未处理' }}
                    </template>
                </el-table-column>
                <el-table-column prop="creationTime" label="创建时间" align="center" width="200px"></el-table-column>
                <el-table-column label="操作" align="center" width="120px">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" size="mini" @click="updateStatus(scope.row)" v-if="!scope.row.chuli">标记处理</el-button>
                        <span v-else>已处理</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
export default {
    name: 'feedback',
    components:{
        queryCondition,
    },
    data () {
        return {
            totalCount:0,
            tableData:[],
            conditionData:{
                userId:'',
                isChuli:'',
                current:1,
                size:10,
            },
            queryList:[
                {type: "input",label: "用户ID:",name: "userId"},
                {type: "select",label: "处理状态:",name: "isChuli",options:[
                    {label:'全部',value:''},
                    {label:'已处理',value:true},
                    {label:'未处理',value:false},
                ]},
            ],
        }
    },
    mounted(){
        setTimeout(() => {
            this.loadingData();
        }, 300)
    },
    methods:{
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let params = {
                current: this.conditionData.current,
                size: this.conditionData.size,
            };
            if (this.conditionData.userId) {
                params.userId = this.conditionData.userId;
            }
            if (this.conditionData.isChuli !== '') {
                params.isChuli = this.conditionData.isChuli;
            }
            let res = await api.FeedbackQuery(params);
            this.tableData = res.data.data.records;
            this.totalCount = res.data.data.total;
            for(let index in this.tableData){
                if(this.tableData[index].path && !this.tableData[index].pathList){
                    this.tableData[index].pathList = this.tableData[index].path.split(',');
                }
            }
        },
        selectData(){
            this.conditionData.current = 1;
            this.loadingData();
        },
        reset(){
            this.conditionData = {
                userId:'',
                isChuli:'',
                current:1,
                size:10,
            };
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.current = page;
            this.loadingData();
        },
        handleSizeChange(pageSize){
            this.conditionData.current = 1;
            this.conditionData.size = pageSize;
            this.loadingData();
        },
        updateStatus(row){
            this.$confirm('确认将该反馈标记为已处理？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let res = await api.FeedbackUpdateIsChuli({
                    id: row.id,
                    isChuli: true
                });
                if(res.data.code == 200 || res.data.code == '200'){
                    this.$message({
                        type: 'success',
                        message: '已处理完成'
                    });
                    this.loadingData();
                }
            }).catch(() => {});
        },
    }
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
    }
    ::v-deep .table-expand {
        font-size: 0;
    }
    ::v-deep .table-expand label {
        width: 200px;
        padding-left: 50px;
        color: #99a9bf;
    }
    ::v-deep .table-expand span {
        color: #222222;
    }
    ::v-deep .table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 100%;
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
</style>
